import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { pStore } from '@/pinia';
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const { itemDetail, } = storeToRefs(pStore.piniaWorkerNotice);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                titleSlot: _withCtx(() => [
                    _createTextVNode(" 상세보기 (No. " + _toDisplayString(_unref(itemDetail).id) + ") ", 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
